<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('base.supplier.supplierCode')" prop="supplierCode">
                <el-input class="handle-input" v-model="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                <el-input v-model="queryCondition.type" v-show="false" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.supplier.supplierName')" prop="supplierName">
                <el-input class="handle-input" v-model="queryCondition.supplierName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.common.status')" prop="status">
                <el-select v-model="queryCondition.status" class="handle-input" style="width:100%">
                  <el-option :label="$t('common.all')" value=""></el-option>
                  <el-option :key="index" v-for="(item,index) in supplierStatusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button size="mini" class="btn" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" type="primary" v-acl="SUPPLIER_GROUP_VIEW" @click="showGroups()">{{$t('base.supplier.editGroup')}}</el-button>
      </el-row>
      <el-table :data="tableData" border max-height='470' highlight-current-row>
        <el-table-column show-overflow-tooltip sortable prop="supplierCode" align="center" :label="$t('base.supplier.supplierCode')" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierName" align="center" :label="$t('base.supplier.supplierName')" min-width="200px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="address" align="center" :label="$t('base.supplier.supplierAddress')" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="postCode" align="center" :label="$t('base.supplier.supplierPostCode')" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="telephoneNo" align="center" :label="$t('base.supplier.supplierTelephoneNo')" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="emailAddress" align="center" :label="$t('base.supplier.supplierEmailAddress')" min-width="150px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="statusI18n" align="center" :label="$t('base.common.status')" min-width="100px"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
      <el-dialog :title="$t('base.supplier.editGroup')" :visible="showGroupDialog" width="1200" @close="showGroupDialog = false">
        <el-row class="action-btn-row">
          <el-button size="mini" type="primary" v-acl="SUPPLIER_GROUP_EDIT" @click="saveGroup()">{{$t("common.save")}}</el-button>
        </el-row>
        <el-row gutter="20">
          <el-col :span="12">
            <el-card>
              <div slot="header" class="clearfix">
                <span>{{$t('base.supplier.group')}}</span>
                <div style="float: right">
                  <el-button size="mini" type="primary" v-acl="SUPPLIER_GROUP_EDIT" @click="addGroup">{{$t('base.supplier.addGroup')}}</el-button>
                  <el-button size="mini" type="danger" v-acl="SUPPLIER_GROUP_EDIT" @click="delGroup">{{$t('common.del')}}</el-button>
                </div>
              </div>
              <el-table ref="groupTable" @current-change="changeCurrentGroup" @select="changeCurrentRow" :data="groups" :row-key="tmSupplierId" highlight-current-row>
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('base.supplier.groupCode')">
                  <template slot-scope="scope">
                    <el-input maxlength="20" v-model="scope.row.supplierCode"></el-input>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('base.supplier.groupName')">
                  <template slot-scope="scope">
                    <el-input maxlength="100" v-model="scope.row.supplierName"></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card>
              <div slot="header" class="clearfix">
                <span>{{$t('base.supplier.supplier')}}</span>
                <el-button size="mini" type="danger" v-acl="SUPPLIER_GROUP_EDIT" style="float: right" @click="delGroupSupplier">{{$t('common.del')}}</el-button>
                <el-button size="mini" type="primary" v-acl="SUPPLIER_GROUP_EDIT" style="float: right;margin-right: 10px;" @click="selectSupplier">{{$t('common.add')}}</el-button>
                <el-dialog append-to-body :visible="selectSupplierDialg" @close="selectSupplierDialg = false" width="80%">
                  <supplier-sel-page :visible="selectSupplierDialg" @subCallMethod="addSupplierToGroup"></supplier-sel-page>
                </el-dialog>
              </div>
              <el-table ref="groupSuppliersTable" :data="groupSuppliers">
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('base.supplier.supplierCode')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('base.supplier.supplierName')"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { search, disable, listGroups, saveGroups, delGroup } from "../../../api/base-data/supplier";
import { Message } from "element-ui";
import { inputChoiceService } from "../../../api/common/input-choice";
import SupplierSelPage from "@/components/page/base-data/supplier-sel-page";
import commonFun from "@/utils/commonFun";
import commonMethods from "@/utils/commonMethods";

export default {
  name: 'supplier',
  components: { SupplierSelPage },
  extends: commonMethods,
  data() {
    return {
      supplier: [],
      tableData: [],
      supplierStatusList: [],
      totalCount: 0,
      labelPosition: 'right',
      showGroupDialog: false,
      selectSupplierDialg: false,
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        status: '',
        supplierCode: '',
        supplierName: '',
        type: 'SUPPLIER'
      },
      currentGroupId: null,
      groups: [{}],
      groupSuppliers: []
    }
  },
  created() {
    this.queryData(1);
    this.getInputChoiceValues();
  },
  computed: {
    currentGroupIndex() {
      console.log('currentGroupId111',this.currentGroupId);
      console.log('groups',this.groups);
      let currentGroupId = this.currentGroupId;
      let currentGroupIndex = null;
      this.groups.forEach((group, index) => {
        if (group.tmSupplierId == currentGroupId) {
          currentGroupIndex = index;
        }
      })
      return currentGroupIndex;
    }
  },
  methods: {
    showGroups() {
      this.showGroupDialog = true;
      this.currentGroupId = null;
      listGroups().then(resp => {
        this.groups = resp.data;
        this.groupSuppliers = [];
      })
    },
    changeCurrentRow(selection, row) {
      console.log('row11111111111111',row);
      this.$refs.groupTable.setCurrentRow(row);
    },
    changeCurrentGroup(row) {
      console.log('row',row);
      console.log('currentGroupIndex',this.currentGroupIndex);
      if (commonFun.isNotEmpty(row)) {
        this.currentGroupId = row.tmSupplierId;
        this.groupSuppliers = this.groups[this.currentGroupIndex].suppliers;
      }
    },
    saveGroup() {
      let groups = this.groups.map(group => {
        group.tmSupplierId = group.tmSupplierId < 0 ? null : group.tmSupplierId;
        group.subIds = group.suppliers.map(sup => sup.tmSupplierId);
        return group;
      });
      saveGroups(this.groups).then(resp => {
        Message.success(this.$t('common.saveSuccess'))
        this.showGroups();
      });
    },
    addGroup() {
      this.groups.push({ tmSupplierId: -new Date().getTime(), suppliers: [] });
    },
    delGroup() {
      let selection = this.$refs.groupTable.selection;
      if (commonFun.isEmpty(selection)) {
        Message.error(this.$t('common.pleaseSelectData'));
        return;
      } else {
        this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          customClass: 'colorBtn',
          type: 'warning'
        })
          .then(() => {
            let supplierIds = selection.filter(row => row.tmSupplierId > 0).map(row => row.tmSupplierId);
            if (commonFun.isNotEmpty(supplierIds)) {
              delGroup(selection.filter(row => row.tmSupplierId > 0).map(row => row.tmSupplierId)).then(resp => {
                this.showGroups();
              });
            } else {
              this.showGroups();
            }
          });
      }
    },
    // showSupplier(group) {
    //   this.groupSuppliers = groups.filter(row => row.tmSupplierId == group.tmSupplierId).suppliers;
    // },
    delGroupSupplier() {
      let selection = this.$refs.groupSuppliersTable.selection;
      if (commonFun.isEmpty(selection)) {
        Message.error(this.$t('common.pleaseSelectData'));
        return;
      } else {
        this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          customClass: 'colorBtn',
          type: 'warning'
        })
          .then(() => {
            let oldSuppliers = this.groups[this.currentGroupIndex].suppliers;
            oldSuppliers = oldSuppliers.filter(supItem => {
              return !selection.some(row => row.tmSupplierId == supItem.tmSupplierId)
            });
            this.groups[this.currentGroupIndex].suppliers = oldSuppliers;
            this.groupSuppliers = oldSuppliers;
          });


      }
    },
    selectSupplier() {
      if (commonFun.isEmpty(this.currentGroupIndex)) {
        Message.error(this.$t("base.supplier.pleaseSelectGroup"));
        return;
      }
      this.selectSupplierDialg = true;
    },
    addSupplierToGroup(suppliers) {
      console.log('suppliers',suppliers);
      let oldSuppliers = this.groups[this.currentGroupIndex].suppliers;
      if (commonFun.isEmpty(oldSuppliers)) {
        oldSuppliers = [];
      }
      oldSuppliers.push(...suppliers);
      console.log('oldSuppliers',oldSuppliers);
      oldSuppliers = commonFun.distinct(oldSuppliers, (supplier) => supplier.tmSupplierId);
      this.groupSuppliers = oldSuppliers;
      this.groups[this.currentGroupIndex].suppliers = oldSuppliers;
      this.selectSupplierDialg = false;
    },
    //查询承运商
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      search(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      })
    },
    //禁用供应商
    disableSupplier() {
      if (this.supplier.length == 0) {
        Message({ message: this.$t('base.supplier.supplierSelect'), type: "warning" });
      } else {
        this.$confirm(this.$t('common.delWarning'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          disable(this.supplier).then((res) => {
            if (res.resultData > 0) {
              Message({ message: this.$t('common.delSuccess'), type: "success" });
              this.queryData();
            } else {
              Message({ message: this.$t('common.delError'), type: "error" });
            }
          });
        }).catch(() => {

        });
      }
    },
    //获取选中承运商编号
    findSupplierCode(val) {
      this.supplier = [];
      val.forEach((item) => {
        this.supplier.push(item.tmSupplierId);
      });
    },
    //新增供应商
    addSupplier() {
      this.$router.replace({
        name: 'supplier-add'
      });
    },

    //获取下拉列表数据
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["COMMON:STATUS_DISABLE_ENABLE"] = "COMMON:STATUS_DISABLE_ENABLE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.supplierStatusList = res["COMMON:STATUS_DISABLE_ENABLE"];
      });
    },

    //分页查询页数变化
    pageNumberChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
    //分页查询每页显示数量变化
    pageSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.queryData();
    },
  }
}
</script>
<style scoped>
.handle-input {
  width: 95%;
}

.query-btn-row {
  width: 30%;
  float: right;
}

.dialog-input {
  width: 40%;
}
</style>
